import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 border-t border-[#00d4ff]/10 text-center bg-[#0f0f1e]" data-id="element-37">
      <div className="max-w-[1200px] mx-auto" data-id="element-38">
        <p className="text-[0.9rem] text-[#666] mb-3" data-id="element-39">
          © 2026 La Fórmula del Dinero Rápido. Todos los derechos reservados.
        </p>
        <div className="flex flex-wrap justify-center items-center gap-2 text-[0.8rem] text-[#666]" data-id="element-40">
          <a href="#" className="hover:text-[#00d4ff] transition-colors" data-id="element-41">
            Política de Privacidad
          </a>
          <span data-id="element-42">|</span>
          <a href="#" className="hover:text-[#00d4ff] transition-colors" data-id="element-43">
            Términos de Servicio
          </a>
          <span data-id="element-44">|</span>
          <a href="#" className="hover:text-[#00d4ff] transition-colors" data-id="element-45">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}